import React from "react";

import { useRouter } from "next/router";

import { ListMap } from "@/lib/list-map/ListMap";

import { LiItem } from "./components/NavLink";
import { useNavLinksArray } from "./components/useNavLinksArray";

type NavItem = {
  iconComponent: React.FC;
  label: string;
  path?: string;
};

type PropTypes = {
  isMainBlockScrolledDown?: boolean;
  withHandleDrawerClose: (fn?: () => void) => () => void;
  isSidebarVersion?: boolean;
};

export const LeftMenuNav: React.FC<PropTypes> = ({
  isMainBlockScrolledDown,
  withHandleDrawerClose,
  isSidebarVersion,
}) => {
  const listItemsMap = useNavLinksArray(isSidebarVersion);
  const router = useRouter();

  return (
    <nav>
      <ul>
        <ListMap
          itemList={listItemsMap}
          RenderItem={(props: NavItem) => {
            const isActive = props.path
              ? router.pathname === props.path
              : false;

            return (
              <LiItem
                isMainBlockScrolledDown={isMainBlockScrolledDown}
                withHandleDrawerClose={withHandleDrawerClose}
                isActive={isActive}
                {...props}
              />
            );
          }}
        />
      </ul>
    </nav>
  );
};
